import Vue from 'vue';

let currentPosition: string, xVal: string, yVal: string, zIndex: string;
let videoPlayer: any;

function setFullScreen(element: HTMLElement) {
    element.style['position'] = 'fixed';
    element.style['zIndex'] = '99999999';
    element.style['top'] = '0px';
    element.style['left'] = '0px';
}

function unsetFullScreen(element: HTMLElement) {
    element.style.position = currentPosition;
    element.style.left = yVal;
    element.style.top = xVal;
    element.style.zIndex = zIndex;
}

function checkOrientation(element: HTMLElement, forceFullScreen: boolean) {
    const orientation = window.screen.orientation.type
    if (orientation.includes('landscape') && window.outerWidth <= 760 &&  forceFullScreen ) {
        setFullScreen(element);
    } else {
        unsetFullScreen(element);
    }
}

export const fullScreenOnLandscapeDirective = {
    bind: function (el: HTMLElement, binding: any) {
        videoPlayer = binding.value.$refs.videoPlayer;

        videoPlayer.addEventListener('timeupdate', function () {
            checkOrientation(el, true);
        });

        //re-play
        videoPlayer.addEventListener('ended', function () {
            checkOrientation(el, false);
        });

    },
    inserted: function (el: HTMLElement) {
        currentPosition = el.style.position;
        xVal = el.style.left;
        yVal = el.style.top;
        zIndex = el.style.zIndex;
    },
};
